import React, { useState, useEffect } from "react";
import MainView from "../../../components/MainView";

import './styles.css';

import billServices from "../../../services/admFin/billServices";
import compare from "../../../functions/compare";

import NavHistory from '../../../components/NavHistory';
import BillsCard from './BillsCard';
import PopupBill from "./PopupBill";
import PopupNewBill from "./PopupNewBill";

export default function BillsPage(props) {

    return (
        <MainView currentPage='bills' admFinMenu>
            <NavHistory navPages={['Contas']} />

            <div className='bills-page-cards'>
                <div className='bills-page-cards-group'>
                    <BillsCard
                        toPay
                    />
                </div>

                <div className='bills-page-cards-group'>
                    <BillsCard
                        toReceive
                    />
                </div>
            </div>
        </MainView>
    )
}